// extracted by css-extract-rspack-plugin
export default {"icon":"_11f20639"};